export default __webpack_public_path__ + "static/media/Call.43ad825e.svg";